/*
 * KnsMallMap - Custom Interactive Map Plugin
 * Version 1.0
 * http://www.kns.com.tr/
 */

const _ = require("lodash");
const Hammer = require("hammerjs");
const MouseWheel = require("imports-loader?define=>false!jquery-mousewheel");
const TweenMax = require("imports-loader?window=>window,document=>document!gsap/TweenMax.js");

const SECOND = 1000;

module.exports = ($) => {

    MouseWheel($);

    const SvgMap = function (element) {

        const self = this;

        self.o = {
            mode: "default",
            // mode: "picker", // backend selection mode
            locationCannotBeSelected: null,
            helperTexts: {
                youAreHere: "You are here"
            },
            strokeOptions: {
                width: 8,
                color: "#000"
            },
            animation: {
                speedFactor: 8,
                mode: "line",
                debugContainer: "#navigation-debugger",
                availableModes: ["line", "dot"]
            },
            selector: "[id^=stores] > *",
            serviceSelector: "[id^=services] > *",
            rotatable90Selector: "[id^=deg-90] > *",
            rotatable180Selector: "[id^=deg-180] > *",
            rectSelector: "[id^=rect] > *",
            noPointerGroupSelector: "g[id^=nopointer]",
            draggable: true,
            landmark: false,
            mapFill: false,
            height: 420,
            zoomToSelected: true,
            rotatable: false,
            action: "tooltip",
            hoverTip: true,
            tooltip: {
                enabled: true,
                navigation: false,
                detail: true
            },
            smartip: true,
            fillColor: "",
            developer: false,
            mouseWheel: true,
            maxScale: 4,
            cssAnimation: false,
            cssAnimationTime: SECOND,
            zoom: true,
            textOnRect: {
                enabled: true,
                maxFontSize: 48,
                minFontSize: 16,
                fontFamily: "serif",
                fillColor: "#ececec"
            },
            beaconMode: false,
            initialScaleFactor: 1
        };

        self.$el = element;
        // self.animation = {};
        self.offsetDueToRotation = 0;

        self.callbackMapReady = null;

        self.init = (options) => {

            const data = options.data;
            options.data = null;

            // check tooltip option is provided and has value true/false
            console.log(_.get(options, "tooltip"));
            
            const tooltipOption = _.get(options, "tooltip");
            if (_.isBoolean(tooltipOption)) {
                options.tooltip = self.o.tooltip;
                options.tooltip.enabled = tooltipOption;
            }
            else if (!_.isBoolean(_.get(options, "tooltip.enabled"))) {
                options.tooltip = options.tooltip || self.o.tooltip;
                options.tooltip.enabled = true;
            }

            // check textOnRect option is provided and has value true/false
            const textOnRectOption = _.get(options, "textOnRect");
            if (_.isBoolean(textOnRectOption)) {
                options.textOnRect = self.o.textOnRect;
                options.textOnRect.enabled = textOnRectOption;
            }
            else if (!_.isBoolean(_.get(options, "textOnRect.enabled"))) {
                options.textOnRect = options.textOnRect || self.o.textOnRect;
                options.textOnRect.enabled = true;
            }

            if (!options.textOnRect.fontFamily) {
                options.textOnRect.fontFamily = "serif";
            }

            if (!options.textOnRect.fillColor) {
                options.textOnRect.fillColor = "#ececec";
            }

            const animationOption = options.animation;
            if (animationOption) {
                if (!options.animation.debugContainer) {
                    options.animation.debugContainer = self.o.animation.debugContainer;
                }
                if (!options.animation.speedFactor) {
                    options.animation.speedFactor = self.o.animation.speedFactor;
                }
                if (!options.animation.mode) {
                    options.animation.mode = self.o.animation.mode;
                }
            }

            // Merging options with defaults
            _.assign(self.o, options);

            self.x = 0;
            self.y = 0;
            self.scale = 1;
            self.rotation = 0;

            self.$el.addClass("svg-map-element svg-map-loading").height(self.o.height);

            // if tooltip disabled, change default action as zoom
            if (!self.o.tooltip.enabled) {
                self.o.action = "zoom";
            }

            self.o.landmark = !!data.landmark;

            // Disable modules when landmark mode is active
            if (self.o.landmark) {

                self.o.hoverTip = false;
                self.o.action = "tooltip";
            }

            if (!self.o.id) {
                self.$el.removeClass("svg-map-loading").addClass("svg-map-error");
                console.error("Map is not set! [svg-map] shortcode must contain an id attribute.");
                return;
            }

            if (_.isNumber(self.o.rotate)) {
                // do not rotate over 360
                self.o.rotate = self.o.rotate % 360;
                // if not multiple of 90, reset rotate
                if (self.o.rotate % 90) {
                    self.o.rotate = 0;
                }
            }
            else {
                self.o.rotate = 0;
            }

            console.log("OPTIONS ARE BELOW:");
            console.log(self.o);
            // console.log("ROTATE OPTION");
            // console.log(self.o.rotate);

            setTimeout(() => {

                console.log("LOADING SVG MAP..");

                processData(data);
                // remove loading spinner when svgs loaded
                // self.$el.removeClass("svg-map-loading");
            }, 100);

            return self;
        };

        // Tooltip
        class Tooltip {

            constructor() {
                this.$el = null;
                this.shift = 6;
                this.drop = 0;
                this.location = null;
            }

            init() {
                console.log("TOOLTIP INIT");

                // Construct
                this.$el = $("<div/>").addClass("svg-map-tooltip");
                let isCloseButtonActive = !self.o.landmark;

                if (isCloseButtonActive) {

                    this.$close = $("<a/>").addClass("svg-map-tooltip-close").attr("href", "#").appendTo(this.$el);
                    this.$close.on("click touchend", function (e) {
                        e.preventDefault();
                        self.hideLocation();
                        if (!self.o.zoom) {
                            moveTo(0.5, 0.5, 1, 1200, "easeInOutCubic");
                        }
                    });
                }

                this.$content = $("<div/>").addClass("svg-map-tooltip-content").addClass(isCloseButtonActive ? "" : "svg-map-tooltip-landmarkmode").appendTo(this.$el);
                this.$title = $("<h4/>").addClass("svg-map-tooltip-title").appendTo(this.$content);

                if (!self.o.landmark && self.o.tooltip.enabled && self.o.tooltip.navigation) {

                    this.$navigation = $("<a/>", {
                        text: self.o.tooltip.navigation["text"]
                    }).addClass("svg-map-tooltip-navigation-button").attr("href", "#").appendTo(this.$content);

                    this.$navigation.on("click touchend", (e) => {

                        e.preventDefault();

                        if (this.$navigation.hasClass("active")) {
                            // navigation stop requested
                            self.$el.trigger("navigationCancelClicked", [this.$navigation, this.location.id]);
                            return;
                        }

                        // navigation start requested
                        self.$el.trigger("navigationClicked", [this.$navigation, this.location.id]);
                    });
                }
                else if (!self.o.landmark && self.o.tooltip.enabled && self.o.tooltip.detail) {

                    this.$detail = $("<a/>", {
                        text: self.o.tooltip.detail["text"] || "DETAIL"
                    }).addClass("svg-map-tooltip-navigation-button").attr("href", "#").appendTo(this.$content);

                    this.$detail.on("click touchend", (e) => {

                        e.preventDefault();

                        // store detail requested
                        self.$el.trigger("detailClicked", [this.$detail, this.location.id]);
                    });
                }

                this.$triangle = $("<div/>").addClass("svg-map-tooltip-triangle").prependTo(this.$el);

                // Append
                self.$map.append(this.$el);
            }

            show(location, duration) {

                // console.log("TOOLTIP SHOW");
                if (!location || location.type === "kiosk") {
                    return;
                }

                this.location = location;

                if (self.hoverTip) {
                    self.hoverTip.hide();
                }

                this.$title.text(getTitle(location));

                if (self.o.tooltip.enabled && self.o.tooltip.navigation && this.$navigation) {
                    this.$navigation.removeClass("active");
                }

                this.$content[0].scrollTop = 0;

                // Shift
                this.shift = 20;

                this.position();

                // Making it visible
                this.$el.stop().show();
                this.$el.css({
                    opacity: 1
                });
                this.zoom(location, duration);
            }

            position() {

                // console.log("TOOLTIP POSITION");
                if (this.location) {
                    // console.log("POSITION TOOLTIP FOR LOCATION ID:" + this.location.id);

                    const cx = self.$map.offset().left + self.$map.width() * getX(this.location) - self.$container.offset().left,
                        cy = self.$map.offset().top + self.$map.height() * getY(this.location) - self.$container.offset().top;

                    let x = getX(this.location) * 100,
                        y = getY(this.location) * 100,
                        mt = -this.$el.outerHeight() - this.shift,
                        ml = -this.$el.outerWidth() / 2;

                    if (self.o.smartip) {
                        // console.log("SMART TIP");

                        let verticalPos = 0.5;

                        // Top check
                        if (Math.abs(mt) > cy) {
                            mt = 8 + 2;
                            this.$el.addClass("svg-map-bottom");
                        }
                        else {
                            this.$el.removeClass("svg-map-bottom");
                        }

                        // Left-right check
                        if (this.$el.outerWidth() / 2 > cx) {
                            verticalPos = 0.5 - (this.$el.outerWidth() / 2 - cx) / this.$el.outerWidth();
                        }
                        else if ((self.$container.width() - cx - this.$el.outerWidth() / 2) < 0) {
                            verticalPos = 0.5 + (cx + this.$el.outerWidth() / 2 - self.$container.width()) / this.$el.outerWidth();
                        }

                        verticalPos = Math.max(0, Math.min(1, verticalPos));

                        ml = -this.$el.outerWidth() * verticalPos;

                        this.$triangle.css("left", Math.max(5, Math.min(95, verticalPos * 100)) + "%");
                    }

                    // console.log({x, y, mt, ml});

                    this.$el.css({
                        left: x + "%",
                        top: y + "%",
                        marginTop: mt,
                        marginLeft: ml
                        // marginTop: 0, // for test purposes
                        // marginLeft: 0
                    });
                    this.drop = this.$el.outerHeight() + this.shift;
                }
            }

            zoom(location, duration) {

                if (!self.o.zoomToSelected) {
                    // no zoom required
                    console.log("NO ZOOM REQUIRED");

                    moveTo(0.5, 0.5, 1, 1200, "easeInOutCubic");
                    return;
                }

                // console.log("TOOLTIP ZOOM");

                // console.log(self.o.maxScale);

                let zoom = location.zoom ? parseFloat(location.zoom) : self.o.maxScale;

                let ry = ((self.$container.height() - this.drop) / 2 + this.drop) / self.$container.height();

                moveTo(getX(location), getY(location), zoom, duration ? duration : 1200, "easeInOutCubic", ry);

            }

            hide() {

                this.location = null;

                this.$el.stop().fadeOut(300, () => {

                    if (self.o.tooltip.enabled && self.o.tooltip.navigation && this.$navigation) {
                        this.$navigation.removeClass("active");
                        this.$navigation.text(self.o.tooltip.navigation["text"]);
                    }

                });
            }

        }

        // HoverTooltip
        class HoverTooltip {

            constructor() {
                this.$el = null;
                this.shift = 6;
            }

            init() {
                const s = this;

                // Construct
                this.$el = $("<div/>").addClass("svg-map-tooltip svg-map-hovertip");
                this.$title = $("<h4/>").addClass("svg-map-tooltip-title").appendTo(this.$el);
                this.$triangle = $("<div/>").addClass("svg-map-tooltip-triangle").appendTo(this.$el);

                // new svg
                if (self.o.selector) {
                    $(self.$map).on("mouseover", self.o.selector, function () {
                        if (!self.navigation.animationStarted()) {
                            const location = getStoreLocationData($(this).attr("id"));
                            s.shift = 20;
                            if (location) {
                                s.show(location);
                            }
                        }
                    }).on("mouseout", function () {
                        s.hide();
                    });
                }

                if (self.o.serviceSelector) {
                    $(self.$map).on("mouseover", self.o.serviceSelector, function () {
                        if (!self.navigation.animationStarted()) {
                            const location = getServiceLocationData($(this).attr("id"));
                            s.shift = 20;
                            if (location) {
                                s.show(location);
                            }
                        }
                    }).on("mouseout", function () {
                        s.hide();
                    });
                }

                self.$map.append(this.$el);
            }

            show(location) {

                if (!location || location.type === "kiosk") {
                    return;
                }

                this.$el.removeClass("svg-map-service-hovertip");

                if (location && location.type === "service") {
                    this.$el.addClass("svg-map-service-hovertip");
                }

                if (_.get(self.tooltip, "location") !== location) {

                    this.$title.text(getTitle(location));
                    this.position(location);
                    this.$el.stop().fadeIn(100);
                }
            }

            position(location) {
                // console.log("REPOSITIONING TOOLTIP..");
                // console.log(`MAP OFFSET (${self.$map.offset().left}, ${self.$map.offset().top})`);
                // console.log(`CONTAINER OFFSET (${self.$container.offset().left}, ${self.$container.offset().top})`);
                // console.log(`CONTENT WIDTH: (${self.contentWidth}, ${self.contentHeight})`);
                // console.log(`CONTAINER WIDTH: (${self.$container.width()}, ${self.$container.height()})`);

                const cx = self.$map.offset().left + self.$map.width() * getX(location) - self.$container.offset().left,
                    cy = self.$map.offset().top + self.$map.height() * getY(location) - self.$container.offset().top;

                // console.log(`CX, CY (${cx}, ${cy})`);

                let x = getX(location) * 100,
                    y = getY(location) * 100,
                    mt = -this.$el.outerHeight() - this.shift,
                    ml;

                let verticalPos = 0.5;

                // Top check
                if (Math.abs(mt) > cy) {
                    mt = 8 + 2;
                    this.$el.addClass("svg-map-bottom");
                }
                else {
                    this.$el.removeClass("svg-map-bottom");
                }

                // Left-right check
                if (this.$el.outerWidth() / 2 > cx) {
                    verticalPos = 0.5 - (this.$el.outerWidth() / 2 - cx) / this.$el.outerWidth();
                }
                else if ((self.$container.width() - cx - this.$el.outerWidth() / 2) < 0) {
                    verticalPos = 0.5 + (cx + this.$el.outerWidth() / 2 - self.$container.width()) / this.$el.outerWidth();
                }

                // console.log(`OUTER DIM: (${this.$el.outerWidth()}, ${this.$el.outerHeight()})`);
                // console.log(`VERTICAL POS: ${verticalPos}`);

                ml = -this.$el.outerWidth() * verticalPos;

                this.$triangle.css("left", Math.max(10, Math.min(90, verticalPos * 100)) + "%");
                this.$el.css({
                    left: x + "%",
                    top: y + "%",
                    marginTop: mt,
                    marginLeft: ml
                    // marginTop: 0, // for test purposes
                    // marginLeft: 0
                });
            }

            hide() {
                this.$el.stop().fadeOut(200);
            }
        }

        // Developer tools
        class DevTools {

            constructor() {
                this.$el = null;
                this.$animationDebugContainer = null;
            }

            init() {
                this.$el = $("<div/>").addClass("svg-map-coordinates").appendTo(self.$container);
                this.$el.append("x: ");
                $("<code/>").addClass("svg-map-coordinates-x").appendTo(this.$el);
                this.$el.append(" y: ");
                $("<code/>").addClass("svg-map-coordinates-y").appendTo(this.$el);

                $(".svg-map-layer", self.$map).on("mousemove", function (e) {
                    const x = (e.pageX - self.$map.offset().left) / self.$map.width(),
                        y = (e.pageY - self.$map.offset().top) / self.$map.height();
                    $(".svg-map-coordinates-x").text(parseFloat(x).toFixed(4));
                    $(".svg-map-coordinates-y").text(parseFloat(y).toFixed(4));
                });


                this.$animationDebugContainer = $("<div/>", {"class": "debug-container"});
                this.$animationDebugContainer.appendTo($(self.o.animation.debugContainer));

                const $buttons = $("<div/>");
                $buttons.append($("<button/>", {"id": "play", "text": "play"}));
                $buttons.append($("<button/>", {"id": "pause", "text": "pause"}));
                $buttons.append($("<button/>", {"id": "reverse", "text": "reverse"}));
                $buttons.append($("<button/>", {"id": "resume", "text": "resume"}));
                $buttons.append($("<button/>", {"id": "restart", "text": "restart"}));
                this.$animationDebugContainer.append($buttons);

                const $sliderWrapper = $("<div/>", {"id": "sliderWrapper"}).append($("<div/>", {"id": "slider"}));
                this.$animationDebugContainer.append($sliderWrapper);

                $("#play").click(function () {
                    // play() only plays forward from current position.
                    // If timeline has finished, play() has nowhere to go.
                    // if the timeline is not done then play() or else restart()
                    // (restart always restarts from the beginning)

                    if (!self.navigation.tween) {
                        return;
                    }

                    if (self.navigation.tween.progress() !== 1) {
                        self.navigation.tween.play();
                    }
                    else {
                        self.navigation.tween.restart();
                    }
                });

                $("#pause").click(function () {
                    if (self.navigation.tween) {
                        self.navigation.tween.pause();
                    }
                });

                $("#reverse").click(function () {
                    if (self.navigation.tween) {
                        self.navigation.tween.reverse();
                    }
                });

                $("#resume").click(function () {
                    if (self.navigation.tween) {
                        self.navigation.tween.resume();
                    }
                });

                $("#restart").click(function () {
                    if (self.navigation.tween) {
                        self.navigation.tween.restart();
                    }
                });
            }

            static startSlider() {
                $("#slider").slider({
                    range: false,
                    min: 0,
                    max: 100,
                    step: .1,
                    slide: function (event, ui) {
                        if (!self.navigation.tween) {
                            return;
                        }

                        self.navigation.tween.pause();
                        // adjust the timeline's progress() based on slider value
                        self.navigation.tween.progress(ui.value / 100);
                    }
                });
            }

            static updateSlider() {
                if (self.navigation.tween) {
                    $("#slider").slider("value", self.navigation.tween.progress() * 100);
                }
            }
        }

        class UserPinTooltip {
            constructor() {
                this.$userPin = null;
                this.$el = null;
                this.shift = 6;
                this.drop = 0;
                this.location = null;
                this.currentUserLocation = null;
            }

            show() {
                this.removeUserLocationPin();

                if (!this.isUserLocationAvailable()) {
                    return;
                }

                const currentLevel = getFloorById(self.currentLevel);
                // console.log(currentLevel.no);

                // user location floor is current floor
                if (!currentLevel || currentLevel.no !== this.currentUserLocation.floorNo) {
                    return;
                }

                // check if waiting for patch
                if (!this.isUserLocationPointAvailable()) {
                    console.log("PATCHING..");

                    const location = this.currentUserLocation.location;
                    setCurrentUserLocation(location);
                }

                // now we have proper x,y points for current user location
                // show user pin
                const $layer = getCurrentLevelLayer(currentLevel.id);

                // console.log($layer);
                // console.log(levelId);

                if (!$layer) {
                    return;
                }

                this.addUserLocationPin($layer);
            }

            addUserLocationPin($layer) {

                let left = this.currentUserLocation.point.x * 100;
                let top = this.currentUserLocation.point.y * 100;

                const $pin = $("<a/>", {
                    href: "#",
                    // class: "svg-map-pin iconpin blue pin-pulse"
                    class: "svg-map-pin iconpin man pin-pulse"
                }).css({
                    "top": top + "%",
                    "left": left + "%"
                }).appendTo($layer);

                $pin.on("click touchend", function (e) {
                    e.preventDefault();
                });

                this.$userPin = $pin;

                this.$el = $("<div/>").addClass("svg-map-tooltip svg-map-hovertip svg-map-you-are-here-hovertip");
                this.$userPinTitle = $("<h4/>").addClass("svg-map-tooltip-title").appendTo(this.$el);
                this.$userPinTriangle = $("<div/>").addClass("svg-map-tooltip-triangle").appendTo(this.$el);

                this.$userPinTitle.text(self.o.helperTexts.youAreHere);

                $layer.append(this.$el);

                // Shift
                this.shift = 50;

                this.position();

                this.$el.stop().fadeIn(100);
            }

            position() {
                // console.log("REPOSITIONING USER PIN TOOLTIP..");

                if (!this.$el) {
                    return;
                }

                // position
                const cx = self.$map.offset().left + self.$map.width() * this.currentUserLocation.point.x - self.$container.offset().left,
                    cy = self.$map.offset().top + self.$map.height() * this.currentUserLocation.point.y - self.$container.offset().top;

                let x = this.currentUserLocation.point.x * 100,
                    y = this.currentUserLocation.point.y * 100,
                    mt = -this.$el.outerHeight() - this.shift,
                    ml = 0;

                if (self.o.smartip) {
                    // console.log("SMART TIP");

                    let verticalPos = 0.5;

                    // Top check
                    if (Math.abs(mt) > cy) {
                        mt = 8 + 2;
                        this.$el.addClass("svg-map-bottom");
                    }
                    else {
                        this.$el.removeClass("svg-map-bottom");
                    }

                    // Left-right check
                    if (this.$el.outerWidth() / 2 > cx) {
                        verticalPos = 0.5 - (this.$el.outerWidth() / 2 - cx) / this.$el.outerWidth();
                    }
                    else if ((self.$container.width() - cx - this.$el.outerWidth() / 2) < 0) {
                        verticalPos = 0.5 + (cx + this.$el.outerWidth() / 2 - self.$container.width()) / this.$el.outerWidth();
                    }

                    verticalPos = Math.max(0, Math.min(1, verticalPos));
                    ml = -this.$el.outerWidth() * verticalPos;
                    this.$userPinTriangle.css("left", Math.max(5, Math.min(95, verticalPos * 100)) + "%");
                }

                this.$el.css({
                    left: x + "%",
                    top: y + "%",
                    marginTop: mt,
                    marginLeft: ml
                });
                this.drop = this.$el.outerHeight() + this.shift;
            }

            // hide() {
            //
            // }

            /**
             *
             * @param x - real x coord in SVG
             * @param y - real y coord in SVG
             * @param z - floor number of point
             */
            addUserLocationPoint(x, y, z) {

                this.currentUserLocation = this.currentUserLocation || new Location();

                this.currentUserLocation.addPoint(x / self.contentWidth, y / self.contentHeight, z);
            }

            /**
             *
             * @param location
             * @param floorNumber
             */
            addUserLocation(location, floorNumber) {
                this.currentUserLocation = new Location(location, floorNumber);
            }

            resetUserLocation() {
                this.removeUserLocationPin();

                this.currentUserLocation = null;
            }

            isUserLocationAvailable() {
                // no point or location provided
                return this.currentUserLocation && this.currentUserLocation.available();
            }

            isUserLocationPointAvailable() {
                return this.currentUserLocation && this.currentUserLocation.pointAvailable();
            }

            getUserLocationFloorNumber() {
                return this.currentUserLocation && this.currentUserLocation.floorNo;
            }

            removeUserLocationPin() {
                // remove user pin
                if (this.$userPin) {
                    this.$userPin.stop().remove();
                }

                if (this.$el) {
                    this.$el.stop().remove();
                }
            }
        }

        class User {
            constructor() {
                this.currentLocation = null;
                this.timelineMax = new TimelineMax();
            }

            init(x, y, z) {
                const point = patchRotatedPoint(x, y);

                this.addUserLocationPoint(point.x, point.y, z);
            }

            show() {
                this.remove();

                const floor = getFloorById(self.currentLevel);

                if (floor.no !== this.getUserLocationFloorNumber() || !this.isUserLocationAvailable()) {
                    console.log("NOT CURRENT FLOOR DO NOT SHOW");
                    return;
                }

                // now we have proper x,y points for current user location
                const $layer = getCurrentLevelLayer(self.currentLevel);

                const $pin = $("<a/>", {
                    href: "#",
                    class: "svg-map-pin circular pin-pulse"
                    // class: "svg-map-pin pin3"
                });

                $pin.on("click touchend", function (e) {
                    e.preventDefault();
                }).appendTo($layer);

                this.$el = $pin;

                let left = this.currentLocation.getX() * 100;
                let top = this.currentLocation.getY() * 100;

                this.$el.css({
                    "top": top + "%",
                    "left": left + "%"
                });
            }

            remove() {
                if (this.$el) {
                    this.$el.stop().remove();
                    this.$el = null;
                }

                if (this.timelineMax) {
                    this.timelineMax.progress(0).clear();
                }
            }

            /**
             *
             * @param x - real x coord in SVG
             * @param y - real y coord in SVG
             * @param z - floor number of point
             */
            addUserLocationPoint(x, y, z) {

                this.currentLocation = this.currentLocation || new Location();

                this.currentLocation.addPoint(x / self.contentWidth, y / self.contentHeight, z);
            }

            changeUserLocationPoint(_points) {
                let points;

                if (!_points) {
                    throw new Error("No points supplied for user location change");
                }

                if (Array.isArray(_points)) {
                    points = _points;
                }
                else {
                    points = [_points];
                }


                if (!this.$el) {
                    // console.log("SETTING FIRST POINT SINCE NO PIN SHOWN BEFORE");

                    const firstPoint = points.shift();
                    self.setCurrentMobileUserLocation(firstPoint.x, firstPoint.y, this.getUserLocationFloorNumber());

                    // console.log(`(${this.currentLocation.getX() * self.contentWidth}, ${this.currentLocation.getY() * self.contentHeight})`);

                }
                // else {
                //     console.log(`(${this.currentLocation.getX() * self.contentWidth}, ${this.currentLocation.getY() * self.contentHeight})`);
                // }

                // console.log(points);

                let currentUserLocationPoint = null;

                // also store first point as user current location
                if (this.currentLocation) {
                    // console.log("ADDING CURRENT LOCATION TO POINTS");

                    currentUserLocationPoint = {
                        x: this.currentLocation.getX() * self.contentWidth,
                        y: this.currentLocation.getY() * self.contentHeight
                    };
                }

                const pathString = Navigation.convertLinesToPath(points);

                if (!pathString) {
                    // no points available, no animation needed
                    return;
                }

                // change current point
                const lastPoint = points[points.length - 1];
                this.init(lastPoint.x, lastPoint.y, this.getUserLocationFloorNumber());
                // console.log(`CHANGED TO LAST POINT: (${this.currentLocation.getX() * self.contentWidth}, ${this.currentLocation.getY() * self.contentHeight})`);

                const path = document.createElementNS("http://www.w3.org/2000/svg", "path"); // Create a path in SVG's namespace
                path.setAttribute("d", pathString); // Set path's data

                const loopLength = path.getTotalLength() + 150;
                console.log("PATH LENGTH: " + loopLength);

                const duration = loopLength * self.o.animation.speedFactor / 4 / SECOND;

                // fix points
                const fixedPoints = _.map(points, (point) => {
                    const fixedPoint = patchRotatedPoint(point.x, point.y);

                    return {
                        left: fixedPoint.x / self.contentWidth * 100 + "%",
                        top: fixedPoint.y / self.contentHeight * 100 + "%"
                    };
                });

                // also store first point as user current location
                if (currentUserLocationPoint) {
                    // console.log("ADDING CURRENT LOCATION TO POINTS");

                    fixedPoints.unshift({
                        left: currentUserLocationPoint.x / self.contentWidth * 100 + "%",
                        top: currentUserLocationPoint.y / self.contentHeight * 100 + "%"
                    });
                }

                // bring playhead back to beginning and clear all tweens
                this.timelineMax.progress(0).clear()
                    .set(this.$el, {
                        css: {
                            left: fixedPoints[0].left,
                            top: fixedPoints[0].top
                        },
                        transformOrigin: "top left"
                    });

                this.timelineMax.to(this.$el, duration * 2, {
                    bezier: {
                        // type: "soft",
                        type: "thru",
                        curviness: 0,
                        values: fixedPoints,
                        autoRotate: 90
                    },
                    //ease for slip-n-slide-like animation wheeee
                    ease: "easeInOutPower2"
                });

            }

            resetUserLocation() {
                this.remove();

                this.currentLocation = null;
            }

            isUserLocationAvailable() {
                return this.currentLocation && this.currentLocation.pointAvailable();
            }

            getUserLocationFloorNumber() {
                return this.currentLocation && this.currentLocation.floorNo;
            }
        }

        class Location {
            constructor(location = null, floorNumber = null) {
                this.point = null;
                this.location = location;
                this.floorNo = floorNumber;
            }

            addPoint(x, y, z) {
                this.point = {x, y};
                this.floorNo = z;

                // no need this location anymore
                // this.location = null;
            }

            available() {
                return this.point || this.location;
            }

            pointAvailable() {
                return this.point && _.isNumber(this.point.x) && _.isNumber(this.point.y);
            }

            getX() {
                return this.point && this.point.x;
            }

            getY() {
                return this.point && this.point.y;
            }
        }

        class Navigation {
            constructor() {
                this.routeData = [];
                this.activeFloors = [];
                this.activeFloor = null;
                this.startLocation = null;
                this.$startPin = null;
                this.endLocation = null;
                this.$endPin = null;
                this.autoMode = false;
                this.started = false;
                this.$path = null;
                this.tween = null;
            }

            init(details) {
                this.routeData = [];
                this.activeFloors = details.direction;
                this.endLocation = getLocationData(details.end);

                if (!this.activeFloors || this.activeFloors.length === 0) {
                    throw new Error("No floors found in SP");
                }

                // TODO add start point?
                if (details.start) {

                    const routeStartData = details.start;
                    // if (routeStartData.point) {
                    //
                    // }
                    // else
                    if (routeStartData.location) {

                        const location = getLocationData(routeStartData.location);
                        if (location) {
                            this.startLocation = new Location(location);
                        }
                    }
                }

                for (let routePerLevel of details.floors) {

                    const floorRouteData = {
                        no: routePerLevel.no,
                        points: []
                    };

                    // console.log("FLOOR NO ", routePerLevel.no);

                    // arrange points in lines
                    for (let line of routePerLevel.lines) {
                        // console.log(line.x1 + ", " + line.y1);

                        floorRouteData.points.push({
                            x: line.x1,
                            y: line.y1
                        });
                    }

                    // also store last point in lines
                    const lastLine = routePerLevel.lines[routePerLevel.lines.length - 1];
                    // console.log(lastLine.x2 + ", " + lastLine.y2);
                    floorRouteData.points.push({
                        x: lastLine.x2,
                        y: lastLine.y2
                    });

                    // TODO arrange point if level shown
                    // change path conversion in show method
                    // if (this.startLocation && routePerLevel.no === 0) {
                    //     console.log("add start point");
                    //     console.log(this.startLocation);
                    //
                    //     routePerLevel.points.unshift({
                    //         x: getX(this.startLocation.location) * self.contentWidth,
                    //         y: getY(this.startLocation.location) * self.contentHeight
                    //     });
                    // }

                    floorRouteData.path = Navigation.convertLinesToPath(floorRouteData.points);

                    if (!floorRouteData.path) {
                        throw new Error("Path cannot be calculated of floor:" + routePerLevel.no);
                    }

                    this.routeData.push(floorRouteData);
                }

                console.log(this.routeData);
                console.log(this.activeFloors);

            }

            setAutoMode(autoMode) {
                this.autoMode = autoMode;
            }

            // TODO
            // addStartPin() {
            //
            // }

            // TODO
            // removeStartPin() {
            //
            // }

            show(autoMode) {
                this.autoMode = autoMode;

                if (this.endLocation && this.endLocation.$el) {
                    removeClass($(".svg-map-active", self.$el), "svg-map-active");
                    removeClass($(".svg-map-navigation-active", self.$el), "svg-map-navigation-active");
                    addClass(this.endLocation.$el, "svg-map-active");
                    addClass(this.endLocation.$el, "svg-map-navigation-active");
                }

                this.showOnLevel(this.activeFloors[0]);
            }

            showOnLevel(floorNo, willSwitchLevel = true) {
                const levelRouteData = _.find(this.routeData, {no: floorNo});

                if (!levelRouteData) {
                    console.log("NO ROUTE DATA");

                    return;
                }

                if (this.activeFloor === floorNo) {
                    console.log("ACTIVE FLOOR SP ALREADY SHOWN");
                    // already on this floor
                    return;
                }

                this.activeFloor = floorNo;

                const pathStringOnLevel = levelRouteData.path;

                const floor = getFloorByNumber(floorNo);

                console.log(levelRouteData);
                console.log(pathStringOnLevel);

                // Hide Tooltip
                if (self.tooltip) {
                    self.tooltip.hide();
                }

                if (willSwitchLevel) {
                    switchLevel(floor.id, true);
                }

                this.removePathAnimations();
                this.animatePathOnLevel(pathStringOnLevel, levelRouteData.points);

                this.started = true;
            }

            animationStarted() {
                return this.started;
            }

            removePathAnimations() {

                if (this.tween) {
                    this.tween.pause();
                    if (this.tween.remove) {
                        this.tween.remove();
                    }
                    this.tween = null;
                }

                if (this.$path) {
                    this.$path.stop().remove();
                    this.$path = null;
                }

                $(".circle.walking").stop().remove();

                this.started = false;
            }

            animatePathOnLevel(pathString, points) {
                console.log(pathString);
                console.log(points);
                // console.log(self.currentLevel);

                const path = document.createElementNS("http://www.w3.org/2000/svg", "path"); // Create a path in SVG's namespace
                path.setAttribute("d", pathString); // Set path's data

                // const triangle = document.createElementNS("http://www.w3.org/2000/svg", "polyline");
                // triangle.setAttribute("points", "0,10 5,0 10,10");
                //

                const loopLength = path.getTotalLength() + 150;
                const duration = loopLength * self.o.animation.speedFactor / SECOND;
                console.log("PATH LENGTH: " + loopLength);
                console.log("ANIMATION DURATION: " + duration);

                const $svgLayer = getCurrentLevelSVGLayer(self.currentLevel);
                const $layer = getCurrentLevelLayer(self.currentLevel);

                this.$path = $(path);

                this.$path.attr({
                    "class": "line",
                    "fill": "none"
                }).css({
                    stroke: self.o.strokeOptions.color,
                    strokeWidth: self.o.strokeOptions.width,
                    strokeMiterlimit: self.o.strokeOptions.width / 2,
                    strokeLinejoin: "round",
                    strokeLinecap: "round",
                    strokeDasharray: loopLength,
                    strokeDashoffset: loopLength
                }).appendTo($svgLayer);

                const bbox = path.getBBox();

                let point = {
                    x: bbox.x + bbox.width / 2,
                    y: bbox.y + bbox.height / 2
                };

                point = patchRotatedPoint(point.x, point.y);

                point = {
                    x: point.x / self.contentWidth,
                    y: point.y / self.contentHeight
                };

                const s = this;
                const coefficientForAnimation = 16 / self.o.animation.speedFactor;

                const $circles = [];
                if (self.o.animation.mode === "dot") {

                    for (let i = 0; i < duration * coefficientForAnimation; i++) {
                        $circles.push($("<a/>", {
                            // "class": "circle walking with-pulse"
                            "class": "circle walking"
                        }));
                    }
                }

                // wait for floor change animation to complete
                setTimeout(function () {

                    // zoom to path's center point
                    moveTo(point.x, point.y, 1.6, 600, "easeInOutCubic");

                    /*
                     $(triangle).attr({
                     "class": "plane",
                     "fill": "#000000"
                     }).appendTo($svgLayer);

                     const $triangle2 = $(triangle).clone().appendTo($svgLayer).hide();

                     const $triangle3 = $(triangle).clone().appendTo($svgLayer).hide();
                     */

                    if (self.o.developer) {
                        DevTools.startSlider();
                    }

                    s.tween = new TimelineMax({
                        onUpdate: self.o.developer ? DevTools.updateSlider : () => {}
                    });

                    if (self.o.animation.mode === "dot") {
                        console.log(`# of circles in animation: ${$circles.length}`);

                        for (let i = 0; i < $circles.length; i++) {
                            $layer.append($circles[i]);
                        }

                        // console.log($circles[0].width() + "x" + $circles[0].height());

                        // fix points
                        const fixedPoints = _.map(points, function (point) {
                            return {
                                left: (point.x - $circles[0].width() / 2) / self.contentWidth * 100 + "%",
                                top: (point.y - $circles[0].height() / 2) / self.contentHeight * 100 + "%"
                            };
                        });

                        const staggerTime = 0.5 / coefficientForAnimation;

                        // bring playhead back to beginning and clear all tweens
                        s.tween.progress(0).clear()
                            .set(".circle.walking", {
                                css: {
                                    left: fixedPoints[0].left,
                                    top: fixedPoints[0].top,
                                    opacity: 0
                                },
                                transformOrigin: "top left"
                            });

                        s.tween.staggerTo(".circle.walking", 0.1, {
                            css: {
                                opacity: 1
                            },
                            ease: "linear"
                        }, staggerTime);
                        //
                        // console.log(s.tween.duration());

                        s.tween.staggerTo(".circle.walking", duration / 2, {
                            bezier: {
                                // type: "soft",
                                type: "thru",
                                curviness: 0,
                                values: fixedPoints,
                                autoRotate: 90
                            },
                            ease: "linear",
                            // repeat: 2,
                            // repeatDelay: 0.5
                        }, staggerTime, `-=${staggerTime * ($circles.length - 1)}`);
                        // }, staggerTime);

                        // console.log(s.tween.duration());
                        s.tween.staggerTo(".circle.walking", 0.1, {
                            css: {
                                opacity: 0
                            },
                            ease: "linear"
                        }, staggerTime, `-=${staggerTime * ($circles.length - 1)}`);

                        console.log(s.tween.duration());

                        setTimeout(() => {
                            animationComplete();
                        }, s.tween.duration() * 1000);
                    }
                    // line
                    else {

                        s.tween.to(s.$path, duration, {
                            strokeDashoffset: 0,
                            ease: "easeInOutPower2",
                            delay: 0,
                            // repeat: -1, yoyo: true,
                            onComplete: animationComplete
                        });
                    }

                    // duration here determined if animation enabled via css
                }, self.o.cssAnimation ? self.o.cssAnimationTime : 100);

                function animationComplete() {
                    console.log("ANIMATION COMPLETE");

                    // animation done advance to next floor?
                    setTimeout(function () {
                        if (s.autoMode && s.started) {
                            s.advanceToNextFloor();
                        }
                    }, SECOND);
                }
            }

            advanceToNextFloor() {
                let currentIndex = this.activeFloors.indexOf(this.activeFloor);

                // do not exceed active floors array length
                let index = Math.min(this.activeFloors.length - 1, currentIndex + 1);

                // last floor reached
                if (currentIndex === index) {
                    return;
                }

                this.showOnLevel(this.activeFloors[index]);
            }

            static convertLinesToPath(points) {
                let pathString = "";

                for (let i = 0; i < points.length; i++) {

                    if (i === 0) {
                        pathString += "M";
                    }

                    const point = points[i];
                    // console.log(point);

                    pathString += `${point.x} ${point.y} `;
                }
                console.log("PATH CALCULATED:" + pathString);

                return pathString.trim();
            }

        }

        // Functions
        const processData = (data) => {

            self.data = data;
            let shownLevel = null;

            self.o.maxScale = parseFloat(self.o.zoomLimit) || self.o.maxScale;

            self.$container = $("<div/>").addClass("svg-map-container").appendTo(self.$el);
            self.$map = $("<div/>").addClass("svg-map-map").appendTo(self.$container);
            if (self.o.zoom) {
                self.$map.addClass("svg-map-zoomable");
            }

            self.$levelSelect = $("<select/>").addClass("svg-map-levels-select");

            if (self.o.rotate === 90 || self.o.rotate === 270) {
                console.log("ROTATE " + self.o.rotate);
                const dimension = Math.max(parseFloat(data.mapWidth), parseFloat(data.mapHeight));
                self.offsetDueToRotation = dimension - Math.min(parseFloat(data.mapWidth), parseFloat(data.mapHeight));

                console.log("OFFSET DUE TO ROTATION " + self.offsetDueToRotation);

                self.contentWidth = dimension;
                self.contentHeight = dimension;
            }
            else {
                console.log("NO ROTATE OR 180");

                self.contentWidth = parseFloat(data.mapWidth);
                self.contentHeight = parseFloat(data.mapHeight);
            }

            self.$container.css("width", "100%");

            let levelsLoaded = 0;

            if (data.levels) {

                for (let level of data.levels) {

                    const svgSource = level.map;

                    // Create new map layer
                    const $layer = $("<div/>", {
                        "class": "svg-map-layer " + (self.o.cssAnimation ? "svg-map-layer-animated " : "") + "svg-map-layer-" + level.no,
                        "data-floor": level.id,
                        "data-floor-number": level.no
                    }).appendTo(self.$map);

                    const $mapHtml = $("<div/>").addClass("svg-map-map-image");
                    $mapHtml.appendTo($layer);

                    $mapHtml.append(svgSource);

                    levelsLoaded++;

                    const $svgLayer = $mapHtml.find("svg");
                    $svgLayer.attr({
                        "class": "svg-map-real-svg"
                    });

                    if (self.o.rotate) {
                        // $mapHtml.css({transform: `rotate(${self.o.rotate}deg)`});
                        rotateElement($mapHtml, self.o.rotate);
                    }

                    level["svgReady"] = true;

                    // Setting up the locations on the map
                    $(self.o.selector, $mapHtml).each(function () {

                        // console.log("LOCATION ID: " + $(this).attr("id"));

                        const location = getStoreLocationData($(this).attr("id"));

                        if (location) {
                            // console.log("LOCATION ID: " + location.id);

                            if (location.action === "not-empty") {
                                // svg not clickable
                                addClass($(this), "svg-map-not-clickable");
                            }
                            else {
                                // fixed in JQuery 3
                                // $(this).addClass("svg-map-clickable");
                                addClass($(this), "svg-map-clickable");
                            }

                            location.$el = $(this);
                        }
                    });

                    $(self.o.serviceSelector, $mapHtml).each(function () {

                        // console.log("SERVICE LOCATION ID: " + $(this).attr("id"));

                        const location = getServiceLocationData($(this).attr("id"));

                        if (location) {
                            // console.log("SERVICE LOCATION ID: " + location.id);

                            // fixed in JQuery 3
                            // $(this).addClass("svg-map-clickable");
                            addClass($(this), "svg-map-clickable");

                            location.$el = $(this);

                            /*
                             let fill = null;
                             if (location.fill) {
                             fill = location.fill;
                             }
                             else if (self.o.fillColor) {
                             fill = self.o.fillColor;
                             }

                             if (location.action === "not-empty") {
                             // skip fill options?
                             }
                             else if (fill) {
                             $(this).css("fill", fill);
                             $("> *", this).css("fill", fill);
                             }
                             */
                        }
                    });

                    // Setting up the rectangles on the map
                    $(self.o.rectSelector, $mapHtml).each(function () {

                        const id = $(this).attr("id");
                        // console.log("RECT ID:" + id);

                        // ID -> xxxx-rect
                        // fetch xxxx part
                        let regex = new RegExp(/(.+)-rect/);
                        let match = id.match(regex);
                        if (!match) {
                            // ID -> rect_xxxx
                            regex = new RegExp(/rect_(.+)/);
                            match = id.match(regex);
                            if (!match) {
                                return;
                            }
                        }

                        // fetch matched group
                        const locationId = match[1];
                        const location = getLocationData(locationId);

                        if (location) {
                            // console.log("ADDING RECT TO LOCATION: " + location.id);

                            location.$rect = $(this);
                        }
                    });

                    // in landmark mode do not attach click handlers
                    if (!self.o.landmark) {

                        // Click event
                        $(self.o.selector, $mapHtml).on("click touchend", function () {
                            console.log("CLICKED, DRAGGING: " + self.dragging);

                            if (!self.dragging) {
                                self.showLocation($(this).attr("id"), 1200);
                            }
                        });

                        // Click event
                        $(self.o.serviceSelector, $mapHtml).on("click touchend", function () {
                            console.log("CLICKED SERVICE, DRAGGING: " + self.dragging);

                            if (!self.dragging) {
                                self.showServiceLocation($(this).attr("id"), 1200);
                            }
                        });
                    }

                    // Trigger floor loaded event
                    self.$el.trigger("floorReady", [level.id, level.no]);

                    // Shown level
                    if (!shownLevel || level.show) {
                        shownLevel = level.id;
                    }

                    // all levels loaded
                    if (levelsLoaded === data.levels.length) {
                        // all loaded succesfully
                        process.nextTick(() => {
                            self.callbackMapReady(shownLevel);
                        });
                    }
                }
            }

            self.callbackMapReady = function (shownLevel) {
                console.log("ALL READY");

                // remove loading spinner
                self.$el.removeClass("svg-map-loading");

                switchLevel(shownLevel);

                // Landmark mode
                if (self.o.landmark && self.data.landmark.id) {

                    if (self.data.landmark.type === "service") {
                        self.showServiceLocation(self.data.landmark.id, 1200, false);
                    }
                    else {
                        self.showLocation(self.data.landmark.id, 1200, false);
                    }
                }
                else {

                    moveTo(0.5, 0.5, 1, 0);
                }

                // now add nodes
                addBeaconNodes((error) => {

                    if (error) {
                        console.log(error);
                        return;
                    }

                    console.log("NODES ADDED");
                });

                // now add texts
                setTimeout(() => {
                    // after texts added, trigger mapReady event
                    addTextsInsideRects((error) => {

                        if (error) {
                            console.log(error);
                            // return;
                        }

                        // Trigger event
                        self.$el.trigger("mapReady");

                        self.callbackMapReady = null;
                    });
                }, 10);
            };

            // COMPONENTS

            // Tooltip (default)
            if (self.o.tooltip.enabled) {
                self.tooltip = new Tooltip();
                self.tooltip.init();
            }

            // user pin tooltip
            self.userPinTooltip = new UserPinTooltip();

            // Hover Tooltip
            if (self.o.hoverTip) {
                self.hoverTip = new HoverTooltip();
                self.hoverTip.init();
            }

            // Developer tools
            if (self.o.developer) {
                self.devTools = new DevTools().init();
            }

            // Navigation Setup
            self.navigation = new Navigation();

            // Browser resize
            $(window).resize(function () {
                // TODO close this? height restriction
                // Mobile
                // if ($(window).width() < 668) {
                //     const height = Math.min(Math.max(self.$container.width() * self.contentHeight / self.contentWidth, $(window).height() * 2 / 3), $(window).height() - 66);
                //     self.$container.height(height);
                // }
                // else {
                //     self.$container.height("100%");
                // }

                self.$container.height("100%");

                const wr = self.$container.width() / self.contentWidth,
                    hr = self.$container.height() / self.contentHeight;

                if (self.o.mapFill) {
                    console.log("MAPFILL");

                    if (wr > hr) {
                        self.fitscale = wr;
                    }
                    else {
                        self.fitscale = hr;
                    }
                }
                else {
                    if (wr < hr) {
                        self.fitscale = wr;
                    }
                    else {
                        self.fitscale = hr;
                    }
                }

                self.scale = normalizeScale(self.scale);
                self.x = normalizeX(self.x);
                self.y = normalizeY(self.y);

                zoomTo(self.x, self.y, self.scale, 100);

            }).resize();

            // Controls
            if (self.o.zoom) {
                addControls();
            }
        };

        const addBeaconNodes = function (callback = () => {
        }) {

            if (!self.o.beaconMode) {
                return;
            }

            for (let level of self.data.levels) {

                if (!level.beacons) {
                    continue;
                }

                const $layer = getCurrentLevelLayer(level.id);

                for (let beacon of level.beacons) {
                    addBeaconNode(beacon, $layer);
                }
            }

            console.log("ALL NODES ADDED TO SVG");
            callback();
        };

        const addBeaconNode = function (node, $layer) {

            const $pin = $("<a/>", {
                "href": "#",
                "class": `svg-map-pin circular ${node.leader ? "pin-md red" : "pin-xs black"} pin-pulse`,
                // "title": node.name,
                "data-title": node.name,
                "data-toggle": "tooltip"
            });

            $pin.on("click touchend", function (e) {
                e.preventDefault();
            }).appendTo($layer);

            let left = getX(node) / self.contentWidth * 100;
            let top = getY(node) / self.contentHeight * 100;

            $pin.css({
                "top": top + "%",
                "left": left + "%"
            });

        };

        const addTextsInsideRects = function (callback = () => {
        }) {

            if (!self.o.textOnRect.enabled) {
                return callback();
            }

            // shift according to max font size / 48
            let shift = {
                horizontal: {
                    x: 0,
                    y: 2 * self.o.textOnRect.maxFontSize / 48
                },
                vertical: {
                    x: 0,
                    y: 2 * self.o.textOnRect.maxFontSize / 48
                }
            };

            // maybe different shift needed for rotations
            // if (self.o.rotate === 90) {
            //
            // }
            // else if (self.o.rotate === 180) {
            //
            // }
            // else if (self.o.rotate === 270) {
            //
            // }

            // console.log("SHIFT OFFSETS");
            // console.dir(shift);

            for (let level of self.data.levels) {
                const $svgLayer = getCurrentLevelSVGLayer(level.id);

                for (let location of level.locations) {
                    if (location.$rect) {
                        addTextIntoRect(location, $svgLayer, shift);
                    }
                }
            }

            console.log("ALL TEXTS ADDED TO SVG");
            callback();
        };

        const addTextIntoRect = function (location, $svgLayer, shift) {

            // now try to add name inside rect

            const rectBBox = location.$rect[0].getBBox();

            const dimension = {
                x: rectBBox.x + rectBBox.width / 2,
                y: rectBBox.y + rectBBox.height / 2
            };

            const maxFont = self.o.textOnRect.maxFontSize;
            const minFont = self.o.textOnRect.minFontSize;

            const text = document.createElementNS("http://www.w3.org/2000/svg", "text"); // Create a text in SVG's namespace
            text.setAttribute("x", dimension.x);
            text.setAttribute("y", dimension.y);

            text.setAttribute("fill", self.o.textOnRect.fillColor);
            text.setAttribute("font-size", `${maxFont}px`);
            text.setAttribute("font-family", self.o.textOnRect.fontFamily);
            text.setAttribute("alignment-baseline", "middle");
            text.setAttribute("text-anchor", "middle");
            text.setAttribute("class", "text-hidden");

            // text.setAttribute("", );

            // const textSpan = document.createElementNS("http://www.w3.org/2000/svg", "tspan"); // Create a text in SVG's namespace
            // textSpan.setAttribute("x", dimension.x);
            // textSpan.setAttribute("y", dimension.y);
            // $(textSpan).html(getTitle(location));
            // $(text).append(textSpan);

            $(text).html(getTitle(location));

            if (self.o.developer) {
                $svgLayer.append($(text));
            }
            else {
                // put texts inside nopointer group
                $(self.o.noPointerGroupSelector, $svgLayer).append($(text));
            }

            // console.log(rectBBox);
            // console.log(text.getBBox());
            // console.log(getTitle(location));

            fitInsideRect(text, maxFont, minFont, shift);
            // fitInsideRectV2(text, maxFont, minFont, shift);

            // TODO textspan case
            function fitInsideRectV2(text, maxFont, minFont, shift) {
                fitInsideRect(text, maxFont, minFont, shift);

                if ($(text).hasClass("visible")) {
                    // console.log("VISIBLE " + getTitle(location));
                    return;
                }

                // console.log("NOT VISIBLE " + getTitle(location));

                const words = getTitle(location).split(" ");

                if (words.length < 2) {
                    // console.log("ONLY ONE WORD, SKIP");
                    return;
                }

                let word;
                word = words.shift();
                if (words.length > 1) {
                    word = word + " " + words.shift();
                }

                // console.log(word);
                // console.log(words);

                $(text).empty();

                let currentFontSize = minFont;

                let textSpan = document.createElementNS("http://www.w3.org/2000/svg", "tspan"); // Create a text in SVG's namespace
                textSpan.setAttribute("x", dimension.x);
                // textSpan.setAttribute("dy", `${currentFontSize}`);
                $(textSpan).html(word);
                $(text).append(textSpan);

                textSpan = document.createElementNS("http://www.w3.org/2000/svg", "tspan"); // Create a text in SVG's namespace
                textSpan.setAttribute("x", dimension.x);
                textSpan.setAttribute("dy", `${currentFontSize}`);
                $(textSpan).html(words.join(" "));
                $(text).append(textSpan);

                $(text).addClass("hidden");

                // console.log(text.getBBox());
                // console.log(rectBBox);

                let newMinFont = Math.round(minFont / 2);

                // VERTICAL, TOP <-> BOTTOM
                if (rectBBox.width < rectBBox.height) {

                    // console.log("TOP-BOTTOM");
                    // console.log(`TEXT DIM: ${text.getBBox().width}, RECT DIM: ${rectBBox.height}`);

                    while (!textFitsInsideRectVertically(text, rectBBox)) {
                        // console.log("DOES NOT FIT");

                        currentFontSize = Math.max(currentFontSize - 2, newMinFont);

                        text.setAttribute("font-size", `${currentFontSize}px`);
                        textSpan.setAttribute("dy", `${currentFontSize}`);

                        if (currentFontSize === newMinFont) {
                            break;
                        }
                    }

                    // check still not fitting
                    if (textFitsInsideRectVertically(text, rectBBox)) {

                        $(text).removeClass("hidden").addClass("visible");
                        // now rotate
                        rotateElementFromCenter(text, self.o.rotate < 90 || self.o.rotate > 180 ? 90 : 270);
                    }
                }
                // HORIZONTAL, LEFT <-> RIGHT
                else {

                    // console.log("LEFT-RIGHT");
                    // console.log(`TEXT DIM: ${text.getBBox().width}, RECT DIM: ${rectBBox.width}`);

                    while (!textFitsInsideRectHorizontally(text, rectBBox)) {
                        // console.log("DOES NOT FIT");

                        currentFontSize = Math.max(currentFontSize - 2, newMinFont);

                        text.setAttribute("font-size", `${currentFontSize}px`);
                        textSpan.setAttribute("dy", `${currentFontSize}`);

                        if (currentFontSize === newMinFont) {
                            break;
                        }
                    }

                    // check still not fitting
                    if (textFitsInsideRectHorizontally(text, rectBBox)) {

                        $(text).removeClass("hidden").addClass("visible");
                        // now rotate
                        rotateElementFromCenter(text, self.o.rotate > 90 ? 180 : 0);
                    }
                }

                function textFitsInsideRectVertically(text, rectBBox) {
                    // not fitting check
                    return !(text.getBBox().width > rectBBox.height || text.getBBox().height > rectBBox.width);
                }

                function textFitsInsideRectHorizontally(text, rectBBox) {
                    return !(text.getBBox().width > rectBBox.width || text.getBBox().height > rectBBox.height);
                }
            }

            function fitInsideRect(text, maxFont, minFont, shift) {

                let currentFontSize = maxFont;

                // VERTICAL, TOP <-> BOTTOM
                if (rectBBox.width < rectBBox.height) {

                    // console.log("TOP-BOTTOM");
                    // console.log(`TEXT DIM: ${text.getBBox().width}, RECT DIM: ${rectBBox.height}`);

                    while (!textFitsInsideRectVertically(text, rectBBox)) {
                        // console.log("DOES NOT FIT");

                        currentFontSize = Math.max(currentFontSize - 2, minFont);

                        text.setAttribute("font-size", `${currentFontSize}px`);

                        if (currentFontSize === minFont) {
                            break;
                        }
                    }

                    // check still not fitting
                    if (textFitsInsideRectVertically(text, rectBBox)) {
                        // console.log("FITTING NOW");

                        // $(text).removeClass("text-hidden").addClass("text-visible");
                        removeClass($(text), "text-hidden");
                        addClass($(text), "text-visible");

                        // shift offset fix when top-bottom
                        text.setAttribute("x", `${dimension.x + shift.vertical.x}`);
                        text.setAttribute("y", `${dimension.y + shift.vertical.y}`);

                        // now rotate
                        rotateElementFromCenter(text, self.o.rotate < 90 || self.o.rotate > 180 ? 90 : 270);
                    }
                }
                // HORIZONTAL, LEFT <-> RIGHT
                else {

                    // console.log("LEFT-RIGHT");
                    // console.log(`TEXT DIM: ${text.getBBox().width}, RECT DIM: ${rectBBox.width}`);

                    while (!textFitsInsideRectHorizontally(text, rectBBox)) {
                        // console.log("DOES NOT FIT");

                        currentFontSize = Math.max(currentFontSize - 2, minFont);

                        text.setAttribute("font-size", `${currentFontSize}px`);

                        if (currentFontSize === minFont) {
                            break;
                        }
                    }

                    // check still not fitting
                    if (textFitsInsideRectHorizontally(text, rectBBox)) {
                        // console.log("FITTING NOW");

                        // $(text).removeClass("text-hidden").addClass("text-visible");
                        removeClass($(text), "text-hidden");
                        addClass($(text), "text-visible");

                        // shift offset fix when left-right
                        text.setAttribute("x", `${dimension.x + shift.horizontal.x}`);
                        text.setAttribute("y", `${dimension.y + shift.horizontal.y}`);

                        // now rotate
                        rotateElementFromCenter(text, self.o.rotate > 90 ? 180 : 0);
                    }
                }

                function textFitsInsideRectVertically(text, rectBBox) {
                    return !(text.getBBox().width > rectBBox.height || text.getBBox().height > rectBBox.width);
                }

                function textFitsInsideRectHorizontally(text, rectBBox) {
                    return !(text.getBBox().width > rectBBox.width || text.getBBox().height > rectBBox.height);
                }
            }

        };

        const addControls = () => {
            const $map = self.$map,
                $mapBody = $(".svg-map-map-image", self.$map);

            if (self.o.landmark) {
                return;
            }

            document.ondragstart = function () {
                return false;
            }; // IE drag fix

            // Drag & drop
            if (self.o.draggable) {
                $mapBody.on("mousedown", function (e) {
                    self.dragging = false;

                    $map.stop();

                    $map.data("mouseX", e.pageX);
                    $map.data("mouseY", e.pageY);
                    $map.data("lastX", self.x);
                    $map.data("lastY", self.y);

                    $map.addClass("svg-map-dragging");

                    self.$map.on("mousemove", function (e) {

                        const diff = Math.abs(e.pageX - $map.data("mouseX"));
                        // console.log("DIFF " + diff);

                        if (!(diff > 1)) {
                            console.log("NOT ENOUGH MOVED, MAYBE IT WAS CLICK");
                            return;
                        }

                        self.dragging = true;

                        let x = e.pageX - $map.data("mouseX") + self.x,
                            y = e.pageY - $map.data("mouseY") + self.y;

                        x = normalizeX(x);
                        y = normalizeY(y);

                        zoomTo(x, y);
                        $map.data("lastX", x);
                        $map.data("lastY", y);
                    });

                    $(document).on("mouseup", function () {

                        self.x = $map.data("lastX");
                        self.y = $map.data("lastY");

                        self.$map.off("mousemove");
                        $(document).off("mouseup");

                        $map.removeClass("svg-map-dragging");

                    });
                });
            }

            // Double click
            self.$el.on("dblclick", ".svg-map-map-image", function (e) {
                e.preventDefault();

                console.log("DOUBLE CLICK");

                const scale = self.scale;

                if (scale === self.o.maxScale) {
                    // if max scale then zoom out to fit scale
                    self.scale = normalizeScale(self.fitscale);
                }
                else {
                    // scale in by factor 2
                    self.scale = normalizeScale(scale * 2);
                }

                self.x = normalizeX(self.x - (e.pageX - self.$container.offset().left - self.x) * (self.scale / scale - 1));
                self.y = normalizeY(self.y - (e.pageY - self.$container.offset().top - self.y) * (self.scale / scale - 1));

                zoomTo(self.x, self.y, self.scale, 400, "easeInOutCubic");
            });

            // Mousewheel
            if (self.o.mouseWheel) {
                $(".svg-map-layer", self.$el).bind("mousewheel DOMMouseScroll", function (e, delta) {
                    const scale = self.scale;

                    self.scale = normalizeScale(scale + scale * delta / 5);

                    // Disable page scroll when zoom is applicable
                    //if (scale !== self.scale) {
                    e.preventDefault();
                    // }

                    self.x = normalizeX(self.x - (e.pageX - self.$container.offset().left - self.x) * (self.scale / scale - 1));
                    self.y = normalizeY(self.y - (e.pageY - self.$container.offset().top - self.y) * (self.scale / scale - 1));

                    zoomTo(self.x, self.y, self.scale, 200, "easeOutCubic");
                });
            }

            // Touch support
            if (!("ontouchstart" in window || "onmsgesturechange" in window)) {
                return true;
            }

            $mapBody.on("touchstart", function (e) {

                self.dragging = false;

                const orig = e.originalEvent,
                    pos = $map.position();

                $map.data("touchY", orig.changedTouches[0].pageY - pos.top);
                $map.data("touchX", orig.changedTouches[0].pageX - pos.left);

                $mapBody.on("touchmove", function (e) {
                    e.preventDefault();
                    self.dragging = true;

                    const orig = e.originalEvent;
                    const touches = orig.touches.length;

                    if (touches === 1) {
                        self.x = normalizeX(orig.changedTouches[0].pageX - $map.data("touchX"));
                        self.y = normalizeY(orig.changedTouches[0].pageY - $map.data("touchY"));

                        zoomTo(self.x, self.y, self.scale, 50);
                    }
                    else {
                        $mapBody.off("touchmove");
                    }
                });

                $mapBody.on("touchend", function () {
                    $mapBody.off("touchmove touchend");
                });
            });

            // Pinch zoom
            const hammer = new Hammer(self.$map[0], {
                transform_always_block: true,
                drag_block_horizontal: true,
                drag_block_vertical: true
            });
            hammer.get("pinch").set({enable: true});

            self.rotating = false;

            let scale = 1, last_scale;
            hammer.on("pinchstart", function () {
                // console.log("PINCH START");

                self.dragging = false;

                scale = self.scale / self.fitscale;
                last_scale = scale;
            });

            hammer.on("pinch", function (e) {
                // console.log("PINCH MOVE");

                self.dragging = true;

                if (e.scale !== 1) {
                    scale = Math.max(1, Math.min(last_scale * e.scale, 100));
                }

                const oldscale = self.scale;
                self.scale = normalizeScale(scale * self.fitscale);

                self.x = normalizeX(self.x - (e.center.x - self.$container.offset().left - self.x) * (self.scale / oldscale - 1));
                self.y = normalizeY(self.y - (e.center.y - self.y) * (self.scale / oldscale - 1)); // - self.$container.offset().top

                zoomTo(self.x, self.y, self.scale, 0);
            });

            if (self.o.rotatable) {
                hammer.get("rotate").set({enable: true});

                let rotation = 0, last_rotation;
                hammer.on("rotatestart rotatemove rotateend", function (e) {
                    switch (e.type) {
                    case "rotatestart":
                        // console.log("ROTATE START");
                        rotation = e.rotation;
                        break;
                    case "rotatemove":
                        console.log("ROTATE MOVE");
                        last_rotation = rotation - e.rotation;

                        rotateTo(self.rotation - last_rotation);
                        break;
                    case "rotateend":
                        // console.log("ROTATE END");
                        self.rotation = self.rotation - last_rotation;
                        break;
                    default:
                        break;
                    }

                });
            }

            // hammer.on("tap", function () {
            //     console.log("tap");
            // });
            //
            // hammer.on("doubletap", function () {
            //     console.log("double tap");
            // });
        };

        /* PRIVATE METHODS */

        // jQuery bug add/remove class workaround (will be fixed in jQuery 3)
        const addClass = ($element, c) => {
            const classes = $element.attr("class");

            if (classes) {
                if (classes.indexOf(c) === -1) {
                    $element.attr("class", classes + " " + c);
                }
            }
            else if ($element && $element[0]) {
                $element[0].classList.add(c);
            }
        };

        const removeClass = ($element, c) => {
            const classes = $element.attr("class");

            if (classes) {
                $element.attr("class", classes.replace(c, "").trim());
            }
            else if ($element && $element[0] && $element[0].classList) {
                $element[0].classList.remove(c);
            }
        };

        const hasClass = ($element, c) => {
            const classes = $element.attr("class");

            if (classes) {
                return (classes.indexOf(c) > -1);
            }
            else if ($element && $element[0] && $element[0].classList) {
                return $element[0].classList.contains(c);
            }

            return false;
        };

        // Normalizing x, y and scale
        const normalizeX = (x) => {
            // console.log(`X: ${x}`);

            const minX = self.$container.width() - self.contentWidth * self.scale;

            if (minX < 0) {
                if (x > 0) {
                    x = 0;
                }
                else if (x < minX) {
                    x = minX;
                }
            }
            else {
                x = minX / 2;
            }

            // console.log(`MIN X: ${minX}`);
            // console.log(`NORMALIZED X: ${x}`);

            return x;
        };

        const normalizeY = (y) => {
            // console.log(`Y: ${y}`);

            const minY = self.$container.height() - self.contentHeight * self.scale;

            if (minY < 0) {
                if (y >= 0) {
                    y = 0;
                }
                else if (y < minY) {
                    y = minY;
                }
            }
            else {
                y = minY / 2;
            }

            // console.log(`MIN Y: ${minY}`);
            // console.log(`NORMALIZED Y: ${y}`);

            return y;
        };

        const normalizeScale = (scale) => {

            if (scale < self.fitscale) {
                scale = self.fitscale;
            }
            else if (scale > self.o.maxScale) {
                scale = self.o.maxScale;
            }

            return scale;
        };

        const zoomTo = (x, y, scale, duration, easing) => {
            // console.log("****ZOOM TO****");
            // console.log(`COORD: (${x},${y}) SCALE: ${scale} DURATION: ${duration}`);

            if (scale !== undefined) {
                // console.log("YES SCALE");

                self.$map.stop().animate({
                    "left": x,
                    "top": y,
                    "width": self.contentWidth * scale,
                    "height": self.contentHeight * scale
                }, duration, easing, function () {
                    if (self.tooltip) {
                        self.tooltip.position();
                    }
                    if (self.userPinTooltip) {
                        self.userPinTooltip.position();
                    }
                });
            }
            else {
                // console.log("NO SCALE");

                self.$map.css({
                    "left": x,
                    "top": y
                });
            }

            if (self.tooltip) {
                self.tooltip.position();
            }

            if (self.userPinTooltip) {
                self.userPinTooltip.position();
            }

            // TODO maybe redraw texts according to zoom scale?

            // Trigger event
            self.$el.trigger("positionChanged", location);
        };

        const moveTo = (x, y, s, duration, easing, ry) => {
            // console.log("****MOVE TO****");
            // console.log(`RATIO: (${x},${y}) SCALE: ${s} DURATION: ${duration}`);

            duration = typeof duration !== "undefined" ? duration : 400;
            ry = typeof ry !== "undefined" ? ry : 0.5;
            s = typeof s !== "undefined" ? Math.min(s * self.o.initialScaleFactor, self.o.maxScale) : self.scale / self.fitscale;

            self.scale = normalizeScale(self.fitscale * s);

            self.x = normalizeX(self.$container.width() * 0.5 - self.scale * self.contentWidth * x);
            self.y = normalizeY(self.$container.height() * ry - self.scale * self.contentHeight * y);

            // console.log(`CONTAINER: (${self.$container.width()}, ${self.$container.height()})`);
            // console.log(`CONTENT: (${self.contentWidth}, ${self.contentHeight})`);
            // console.log(`RY: ${ry} FITSCALE: ${self.fitscale} SCALE: ${s}`);
            // console.log(`COORD: (${self.x},${self.y}) SCALE: ${self.scale} DURATION: ${duration}`);

            zoomTo(self.x, self.y, self.scale, duration, easing);
        };

        const rotateTo = (degree) => {
            rotateElement(self.$map, degree);
        };

        const rotateElement = (element, degree, centered = false, onComplete = null) => {
            const tweenParams = {
                rotation: degree
            };

            if (centered) {
                tweenParams.transformOrigin = "center center";
            }

            if (onComplete) {
                tweenParams.onComplete = onComplete;
            }

            TweenMax.set(element, tweenParams);
        };

        const rotateElementFromCenter = (element, degree, onComplete) => {
            rotateElement(element, degree, true, onComplete);
        };

        const setCurrentUserLocation = (location) => {
            // we need real coordinates
            const point = {
                x: getX(location) * self.contentWidth,
                y: getY(location) * self.contentHeight
            };
            self.setCurrentLocation(point.x, point.y, self.userPinTooltip.getUserLocationFloorNumber());
        };

        const showUserLocation = () => {

            if (self.userPinTooltip) {
                self.userPinTooltip.show();
            }

            if (self.user) {
                self.user.show();
            }

        };

        const getLocationFloor = (id) => {

            let data;

            for (let level of self.data.levels) {

                data = _.find(level.locations, {id});

                if (data) {
                    // location is on this floor
                    // return {no: level.no, id: level.id};
                    return level;
                }
            }

            return null;
        };

        const getLocationData = (id, type) => {

            if (!id) {
                return null;
            }

            let data;

            let query = {id};
            if (type) {
                query.type = type;
            }
            // console.log(query);

            for (let level of self.data.levels) {

                data = _.find(level.locations, query);

                if (data) {
                    break;
                }
            }

            return data;
        };

        const getStoreLocationData = (id) => {
            if (self.o.mode === "picker") {
                return getLocationData(id);
            }

            return getLocationData(id, "store");
        };

        const getServiceLocationData = (id) => {
            if (self.o.mode === "picker") {
                return getLocationData(id);
            }

            return getLocationData(id, "service") || getLocationData(id, "kiosk");
        };

        const getFloorById = (id) => {
            return _.find(self.data.levels, {id});
        };

        const getFloorByNumber = (no) => {
            return _.find(self.data.levels, {no});
        };

        const getCurrentLevelLayer = (levelId) => {

            return $(".svg-map-layer[data-floor=\"" + levelId + "\"]", self.$el);
        };

        const getCurrentLevelSVGLayer = (levelId) => {

            return getCurrentLevelLayer(levelId).find("svg");
        };

        const getTitle = (location) => {
            let title = location.title;

            // if location has title as array, merge them
            if (Array.isArray(title)) {
                let joinWith = location.join || " / ";

                if (joinWith.length === 1) {
                    joinWith = ` ${joinWith} `;
                }

                title = title.join(joinWith);
            }

            return title;
        };

        const getX = (location) => {
            // if location has no x or y values, then it is NOT patched before
            if (!location.x || !location.y) {
                locationMonkeyPatch(location);
            }

            return location.x;
        };

        const getY = (location) => {
            // if location has no x or y values, then it is NOT patched before
            if (!location.x || !location.y) {
                locationMonkeyPatch(location);
            }

            return location.y;
        };

        // rotate point according to self.o.rotate option and
        // apply offset fix
        const patchRotatedPoint = (x, y) => {
            let point = {x, y};

            if (self.o.rotate === 90) {
                point = {
                    x: self.contentWidth - point.y - self.offsetDueToRotation / 2,
                    y: point.x
                };
            }
            else if (self.o.rotate === 270) {
                point = {
                    x: point.y + self.offsetDueToRotation / 2,
                    y: self.contentHeight - point.x
                };
            }
            else if (self.o.rotate === 180) {
                point = {
                    x: self.contentWidth - point.x,
                    y: self.contentHeight - point.y
                };
            }

            return point;
        };

        // location x, y values are calculated after floor is shown to user, this is called only for the first time
        const locationMonkeyPatch = (location) => {
            // NOW LOCATION MONKEY PATCH
            // console.log("MONKEY PATCH LOCATION:" + location.id);

            // location shaped like L, so use our value instead
            if (location.x && location.y) {
                // console.log("SKIPPING LOCATION " + location.id + " X & Y ALREADY PROVIDED");
                return;
            }

            // location matching path/polygon not found in svg
            if (!location.$el || !location.$el[0]) {
                // console.log("SKIPPING LOCATION " + location.id + " NOT FOUND IN SVG");
                return;
            }

            // location has matching rectangle
            if (location.$rect && location.$rect[0]) {
                // use its coordinates for patch
                const locationRectSVGElement = location.$rect[0];

                if (locationRectSVGElement) {
                    const bbox = locationRectSVGElement.getBBox();

                    if (bbox) {
                        // console.log("BBOX OF RECT:" + location.id);
                        // console.log(bbox);

                        let point = {
                            x: bbox.x + bbox.width / 2,
                            y: bbox.y + bbox.height / 2
                        };

                        point = patchRotatedPoint(point.x, point.y);

                        // console.log(point);

                        location.x = point.x / self.contentWidth;
                        location.y = point.y / self.contentHeight;

                        // console.log(`CONTENT (${self.contentWidth}, ${self.contentHeight})`);
                        // console.log(`LOCATION (${location.x}, ${location.y})`);
                    }
                    else {
                        // console.log("NO BBOX");
                    }
                    return;
                }
            }

            // location does not have rectangle, so use its path/polygon for patch
            const locationSVGElement = location.$el[0];

            if (locationSVGElement) {
                const bbox = locationSVGElement.getBBox();

                if (bbox) {
                    // console.log("BBOX OF ELEMENT:" + location.id);
                    // console.log(bbox);

                    let point = {
                        x: bbox.x + bbox.width / 2,
                        y: bbox.y + bbox.height / 2
                    };

                    point = patchRotatedPoint(point.x, point.y);

                    // console.log(point);

                    location.x = point.x / self.contentWidth;
                    location.y = point.y / self.contentHeight;

                    // console.log(`CONTENT (${self.contentWidth}, ${self.contentHeight})`);
                    // console.log(`LOCATION (${location.x}, ${location.y})`);
                }
                else {
                    // console.log("NO BBOX");
                }

            }
        };

        const switchLevel = (floorId, resetZoom) => {

            // reset zoom immediately
            if (resetZoom) {
                moveTo(0.5, 0.5, 1, 0);
            }

            // No such floor
            if (!floorId) {
                return;
            }

            const selectedLevel = getFloorById(floorId);

            if (!selectedLevel) {
                return;
            }

            const $layer = getCurrentLevelLayer(floorId);

            console.log(`FLOOR CURRENT:${self.currentLevelNumber}, SWITCH TO:${selectedLevel.no}`);

            // Target layer is already visible
            if (!self.o.cssAnimation && $layer.hasClass("layer-visible")) {
                console.log("** ALREADY SWITCHED **");
                console.log("**********************");
                return;
            }

            if (self.currentLevel === floorId) {
                console.log("-- ALREADY SWITCHED --");
                console.log("----------------------");
                return;
            }

            // Hide Tooltip
            if (self.tooltip) {
                self.tooltip.hide();
            }

            // rotation of service & other blocks
            if (self.o.rotate) {

                $(self.o.serviceSelector, $layer).each(function () {
                    // console.log("CHANGE ROTATION OF SERVICES");

                    rotateElementFromCenter(this, 360 - self.o.rotate);
                });

                // always rotate below inside dummies deg-90 group
                $(self.o.rotatable90Selector, $layer).each(function () {
                    // console.log("CHANGE ROTATION OF ROTATABLE GROUPS");

                    rotateElementFromCenter(this, 360 - self.o.rotate);
                });

                // only rotate below inside dummies deg-180 group when rotation 180
                if (self.o.rotate === 180) {
                    $(self.o.rotatable180Selector, $layer).each(function () {
                        // console.log("CHANGE ROTATION OF ROTATABLE GROUPS");

                        rotateElementFromCenter(this, 360 - self.o.rotate);
                    });
                }

            }

            if (self.o.cssAnimation) {
                // Animate target layer and others
                for (let level of self.data.levels) {
                    self.$map.removeClass("map--selected-" + level.no);
                }
                self.$map.addClass("map--selected-" + $layer.attr("data-floor-number"));
            }
            else {
                // Show target layer
                $(".svg-map-layer.layer-visible", self.$map).removeClass("layer-visible");
                $layer.addClass("layer-visible");
            }

            self.currentLevel = floorId;
            self.currentLevelNumber = selectedLevel.no;

            // if supplied previously show user location
            showUserLocation();

            console.log("SWITCHED LEVEL");
            console.log("**************");

            // Trigger event
            self.$el.trigger("levelSwitched", [selectedLevel.id, selectedLevel.no]);
        };

        self.zoomIn = () => {

            const scale = self.scale;
            self.scale = normalizeScale(scale + scale * 0.8);

            self.x = normalizeX(self.x - (self.$container.width() / 2 - self.x) * (self.scale / scale - 1));
            self.y = normalizeY(self.y - (self.$container.height() / 2 - self.y) * (self.scale / scale - 1));

            zoomTo(self.x, self.y, self.scale, 400, "easeInOutCubic");
        };

        self.zoomOut = () => {

            const scale = self.scale;
            self.scale = normalizeScale(scale - scale * 0.4);

            self.x = normalizeX(self.x - (self.$container.width() / 2 - self.x) * (self.scale / scale - 1));
            self.y = normalizeY(self.y - (self.$container.height() / 2 - self.y) * (self.scale / scale - 1));

            zoomTo(self.x, self.y, self.scale, 400, "easeInOutCubic");
        };

        self.resetLevel = () => {

            // reset rotation of map
            rotateTo(0);

            self.hideLocation();

            moveTo(0.5, 0.5, 1, 400, "easeInOutCubic");
        };

        /* PUBLIC METHODS */

        self.switchLevelToNumber = (floorNo, resetZoom) => {

            const selectedLevel = getFloorByNumber(floorNo);

            if (selectedLevel) {
                self.navigation.setAutoMode(false);

                switchLevel(selectedLevel.id, resetZoom);

                if (self.navigation.animationStarted()) {
                    self.navigation.showOnLevel(selectedLevel.no, false);
                }
            }
        };

        self.highlightLocation = (id, zoomEnabled, duration) => {

            console.log("HIGHLIGHT LOCATION? " + id);

            const location = getStoreLocationData(id);

            if (!location) {
                return;
            }

            const level = getLocationFloor(location.id);

            if (!level) {
                return;
            }

            switchLevel(level.id);

            if (zoomEnabled) {
                let zoom = location.zoom ? parseFloat(location.zoom) : self.o.maxScale;
                // console.log("ZOOM: " + zoom);
                moveTo(getX(location), getY(location), zoom, duration, "easeInOutCubic");
            }

            removeClass($(".svg-map-navigation-active", self.$el), "svg-map-navigation-active");
            removeClass($(".svg-map-active", self.$el), "svg-map-active");
            if (location.$el) {
                addClass(location.$el, "svg-map-active");
            }

            // Trigger event
            self.$el.trigger("locationHighlighted", location);
        };

        self.showLocation = (id, duration, closeNavigation = true) => {

            console.log("SHOW LOCATION? " + id);

            const location = getStoreLocationData(id);

            if (!location) {
                return;
            }

            const level = getLocationFloor(location.id);

            if (!level) {
                return;
            }

            // console.log("CLOSE NAV?", closeNavigation);

            // first remove animation if any
            if (closeNavigation) {
                self.closeNavigation();
            }

            let action = (location.action && location.action !== "default") ? location.action : self.o.action;

            // landmark mode
            // check default zoom option wanted or not
            const zoomOption = (self.data.landmark || {}).zoom;
            if (self.o.landmark && (_.isBoolean(zoomOption) && !zoomOption)) {
                console.log("ZOOM NOT ENABLED FOR LANDMARK");

                action = "tooltip";
                self.o.zoomToSelected = false;
            }

            // console.log("ACTION: " + action);

            if (action === "select") {

                if (location.$el) {
                    if (hasClass(location.$el, "svg-map-active")) {
                        removeClass(location.$el, "svg-map-active");
                    }
                    else {
                        addClass(location.$el, "svg-map-active");
                    }
                }
            }
            else if (action === "zoom") {

                switchLevel(level.id);
                let zoom = location.zoom ? parseFloat(location.zoom) : self.o.maxScale;
                // console.log("ZOOM: " + zoom);
                moveTo(getX(location), getY(location), zoom, duration, "easeInOutCubic");
            }
            else if (action === "tooltip") {

                switchLevel(level.id);

                if (self.tooltip) {
                    self.tooltip.show(location, duration);
                }
            }
            else if (action === "not-empty") {
                // location not empty case
                if (self.o.locationCannotBeSelected) {
                    self.o.locationCannotBeSelected(location.id);
                }
                return;
            }

            removeClass($(".svg-map-navigation-active", self.$el), "svg-map-navigation-active");
            removeClass($(".svg-map-active", self.$el), "svg-map-active");
            if (location.$el) {
                addClass(location.$el, "svg-map-active");

                /*self.locationTween = TweenMax.fromTo(location.$el, 1, {
                 // y: "+=50",
                 // scale: 1.1,
                 // z: "+=50",
                 // transformOrigin: "center center",
                 fill: "blue"
                 }, {
                 // y: "+=50",
                 // scale: 1.1,
                 // z: "+=50",
                 // transformOrigin: "center center",
                 fill: "green",
                 ease: "easeInOutPower2",
                 // delay: 0,
                 repeat: -1, yoyo: true,
                 onStart: function () {
                 console.log("TWEEN STARTED");

                 },
                 onComplete: function () {
                 console.log("TWEEN HEHE");

                 }
                 });*/
            }

            // Trigger event
            self.$el.trigger("locationOpened", {
                id: location.id,
                title: getTitle(location),
                type: location.type
            });
        };

        self.highlightServiceLocation = (id, zoomEnabled, duration) => {

            console.log("HIGHLIGHT LOCATION? " + id);

            const location = getServiceLocationData(id);

            if (!location) {
                return;
            }

            const level = getLocationFloor(location.id);

            if (!level) {
                return;
            }

            switchLevel(level.id);

            if (zoomEnabled) {
                let zoom = location.zoom ? parseFloat(location.zoom) : self.o.maxScale;
                // console.log("ZOOM: " + zoom);
                moveTo(getX(location), getY(location), zoom, duration, "easeInOutCubic");
            }

            removeClass($(".svg-map-navigation-active", self.$el), "svg-map-navigation-active");
            removeClass($(".svg-map-active", self.$el), "svg-map-active");
            if (location.$el) {
                addClass(location.$el, "svg-map-active");
            }

            // Trigger event
            self.$el.trigger("serviceLocationHighlighted", location);
        };

        self.showServiceLocation = (id, duration) => {

            console.log("SHOW SERVICE LOCATION? " + id);

            const location = getServiceLocationData(id);

            if (!location || location.type === "kiosk") {
                return;
            }

            const level = getLocationFloor(location.id);

            if (!level) {
                return;
            }

            // first remove animation if any
            self.closeNavigation();

            // landmark mode
            // check default zoom option wanted or not
            const zoomOption = (self.data.landmark || {}).zoom;
            if (self.o.landmark && (_.isBoolean(zoomOption) && !zoomOption)) {
                console.log("ZOOM NOT ENABLED FOR LANDMARK");
                self.o.zoomToSelected = false;
            }

            // switchLevel(level.id);
            // let zoom = location.zoom ? parseFloat(location.zoom) : self.o.maxScale;
            // console.log("ZOOM: " + zoom);
            // moveTo(getX(location), getY(location), zoom, duration, "easeInOutCubic");

            switchLevel(level.id);

            if (self.tooltip) {
                self.tooltip.show(location, duration);
            }

            removeClass($(".svg-map-navigation-active", self.$el), "svg-map-navigation-active");
            removeClass($(".svg-map-active", self.$el), "svg-map-active");
            if (location.$el) {
                addClass(location.$el, "svg-map-active");
            }

            // Trigger event
            self.$el.trigger("serviceLocationOpened", location);
        };

        self.hideLocation = () => {

            removeClass($(".svg-map-navigation-active", self.$el), "svg-map-navigation-active");
            removeClass($(".svg-map-active", self.$el), "svg-map-active");

            if (self.tooltip) {
                self.tooltip.hide();
            }

            // Trigger event
            self.$el.trigger("locationClosed");
        };

        self.setCurrentLocationFromBlock = (locationId) => {
            // console.log("LOCATION PIN: " + locationId);

            const location = getLocationData(locationId);

            if (!location) {
                console.log("location not found");
                return;
            }

            // console.log(location);

            const locationFloor = getLocationFloor(locationId);
            // console.log(locationFloor);

            const currentFloor = getFloorById(self.currentLevel);
            // console.log(currentFloor.no);

            self.userPinTooltip.addUserLocation(location, locationFloor.no);

            if (currentFloor.no === self.userPinTooltip.getUserLocationFloorNumber()) {
                console.log("set current location");

                setCurrentUserLocation(location);
            }
            else {
                console.log("wait for patch..");
            }

        };

        self.setCurrentLocation = (x, y, z) => {
            // console.log("in set current user location");
            // console.log(`( ${x},${y} ) in coord`);

            let level;

            // check if a proper value provided
            if (_.isNumber(z)) {
                // console.log("floor: " + z);
                level = getFloorByNumber(z);
            }
            else {
                level = getFloorById(self.currentLevel);
            }

            // console.log(level);

            self.userPinTooltip.addUserLocationPoint(x, y, level.no);

            // console.log("SETTING NEW LOCATION TO");
            // console.log(self.userPinTooltip.currentUserLocation);

            const floor = getFloorById(self.currentLevel);

            if (floor.no === self.userPinTooltip.getUserLocationFloorNumber()) {
                // console.log("show?");

                showUserLocation();
            }
        };

        self.resetCurrentLocation = () => {
            self.userPinTooltip.resetUserLocation();
        };

        self.setCurrentMobileUserLocation = (x, y, z) => {
            let level;

            // check if a proper value provided
            if (_.isNumber(z)) {
                // console.log("floor: " + z);
                level = getFloorByNumber(z);
            }
            else {
                level = getFloorById(self.currentLevel);
            }

            // console.log(level);

            if (!self.user) {
                self.user = new User();
            }
            else {
                self.user.resetUserLocation();
            }

            self.user.init(x, y, level.no);
            self.user.show();
        };

        self.showCurrentMobileUserLocation = () => {
            if (!self.user) {
                return;
            }

            // switch to user's last known floor
            const floorNo = self.user.getUserLocationFloorNumber();
            self.switchLevelToNumber(floorNo);

            // switch level already shows user location if available
        };

        self.moveCurrentMobileUserLocation = (userLocationDetails) => {
            if (!self.user) {
                return;
            }

            try {
                self.user.changeUserLocationPoint(userLocationDetails);
                return true;
            }
            catch (e) {
                console.log(e);
                return false;
            }
        };

        self.resetCurrentMobileUserLocation = () => {
            if (!self.user) {
                return;
            }

            self.user.resetUserLocation();
        };

        self.showNavigation = (navigationDetails, autoMode = true) => {

            try {
                self.navigation.init(navigationDetails);
                self.navigation.show(autoMode);
                return true;
            }
            catch (e) {
                console.log(e);
                return false;
            }

        };

        self.closeNavigation = (resetLevel = true) => {

            this.navigation.removePathAnimations();
            this.navigation.setAutoMode(false);
            this.navigation.activeFloor = null;

            if (resetLevel) {
                self.resetLevel();
            }

            self.$el.trigger("navigationCancelled");
        };

        self.mto = (x, y, s, duration, easing, ry) => {
            moveTo(x, y, s, duration, easing, ry);
        };

        self.zto = (x, y, scale, duration, easing) => {
            zoomTo(x, y, scale, duration, easing);
        };

    };

    // Easing functions used by default
    // For the full list of easing functions use jQuery Easing Plugin
    $.extend($.easing,
        {
            def: "easeOutQuad",
            swing: function (x, t, b, c, d) {
                //alert(jQuery.easing.default);
                return $.easing[$.easing.def](x, t, b, c, d);
            },
            easeOutQuad: function (x, t, b, c, d) {
                return -c * (t /= d) * (t - 2) + b;
            },
            easeOutCubic: function (x, t, b, c, d) {
                return c * ((t = t / d - 1) * t * t + 1) + b;
            },
            easeInOutCubic: function (x, t, b, c, d) {
                if ((t /= d / 2) < 1) {
                    return c / 2 * t * t * t + b;
                }
                return c / 2 * ((t -= 2) * t * t + 2) + b;
            }
        });

    // jQuery Plugin
    $.fn.svgMap = function (options) {

        return this.each(function () {
            const $element = $(this);

            // Plugin already initiated on element
            if ($element.data("svg-map")) {
                return;
            }

            const instance = (new SvgMap($element)).init(options);

            // Store plugin object in element's data
            $element.data("svg-map", instance);
        });
    };

};


// WEBPACK FOOTER //
// src/map.js